import {BMTheme} from "../../BMTheme";

export const listStyle = {
  virtualSlipList: {
    lineHeight: "2em"
  },

  link: {
    color: BMTheme.palette.primary1Color
  }
};



// WEBPACK FOOTER //
// ./src/containers/BulkDelete/style.js